import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const success = () => {
  store.dispatch('group/getGroup');
};

// When the request fails
const failed = () => {};

export default (group) => {
  if (
    !group.name
  ) {
    failed();
  } else {
    Vue.$http
      .post('CustomerGroups', group)
      .then((response) => {
        success(response);
      })
      .catch((error) => {
        failed(error);
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/group/create.js